import { registerPlugin } from "@capacitor/core";

/**
 * iOS `ASWebAuthenticationSession` 을 감싼 Capacitor 플러그인.
 *
 * SFSafariViewController + custom URL scheme 콜백 조합은 iOS 의 navigation
 * 위임 동작 때문에 빈 화면에 갇히는 케이스가 있어, OAuth 흐름은 이 플러그인을
 * 통해 ASWebAuthenticationSession (iOS 12+ 공식 OAuth API) 으로 처리한다.
 *
 * - 시트가 `callbackScheme://...` 으로 리다이렉트되면 자동으로 dismiss 되고
 *   callback URL 이 `url` 에 담겨 resolve 된다.
 * - 사용자가 시트를 직접 닫으면 `USER_CANCELED` 로 reject 된다.
 * - native iOS 빌드에서만 동작; web 빌드는 호출 자체를 우회해야 한다
 *   (현재 `native-oauth.ts` 가 `Capacitor.isNativePlatform()` 으로 분기).
 */
export interface WebAuthSessionPlugin {
  start(options: {
    url: string;
    callbackScheme: string;
    prefersEphemeralWebBrowserSession?: boolean;
  }): Promise<{ url: string }>;
}

export const WebAuthSession =
  registerPlugin<WebAuthSessionPlugin>("WebAuthSession");
